/**
 * Tabelas no celular: cada linha vira um cartão e cada célula mostra o nome da coluna acima do
 * valor. Para isso cada `<td>` precisa saber o título da sua coluna — este módulo lê o `<thead>` e
 * grava `data-label` nas células, sempre que uma tabela aparece ou muda (as páginas redesenham o
 * `<tbody>` o tempo todo). O visual fica todo no CSS (`table.rt`, até 760 px).
 *
 * Regras:
 * - só tabelas com `<thead>` entram (as sem cabeçalho já são listas simples);
 * - a primeira coluna com título (que não seja "#") vira o título do cartão (`td-title`);
 * - colunas sem título (ações) ocupam a linha inteira no fim do cartão (`td-actions`);
 * - `colspan` (linha de "vazio") ocupa o cartão inteiro.
 */
export function installResponsiveTables(root: ParentNode = document): void {
  let scheduled = false;
  const run = (): void => { scheduled = false; labelAll(root); };
  // setTimeout e não requestAnimationFrame: o rAF para em abas em segundo plano e as células ficariam sem rótulo
  const schedule = (): void => { if (!scheduled) { scheduled = true; window.setTimeout(run, 0); } };
  new MutationObserver(schedule).observe(root instanceof Document ? root.body : (root as Node), { childList: true, subtree: true });
  schedule();
}

function labelAll(root: ParentNode): void {
  root.querySelectorAll<HTMLTableElement>('table').forEach(table => {
    const head = table.tHead?.rows[0];
    if (!head) return;
    const labels = Array.from(head.cells).map(th => (th.textContent ?? '').trim());
    const titleIdx = labels.findIndex(l => l && l !== '#');
    table.classList.add('rt');
    Array.from(table.tBodies).forEach(tb => Array.from(tb.rows).forEach(tr => {
      let col = 0;
      Array.from(tr.cells).forEach(td => {
        const span = td.colSpan || 1;
        if (span > 1) { td.classList.add('td-full'); col += span; return; }
        const label = labels[col] ?? '';
        if (td.dataset.label !== label) td.dataset.label = label;
        td.classList.toggle('td-title', col === titleIdx);
        td.classList.toggle('td-actions', !label);
        td.classList.toggle('td-index', label === '#');
        col += 1;
      });
    }));
  });
}
